import { calcIndentation } from './TreeItem';
import { View } from '#UNSAFE_View';
import { Skeleton } from '#UNSAFE_Skeleton';
import { Flex } from '#UNSAFE_Flex';
import { Size } from '#utils/UNSAFE_size';

type Props = {
  indentation?: number;
  isLeaf?: boolean;
};

function TreeItemSkeleton({ indentation = 0, isLeaf = false }: Props) {
  return (
    <View paddingInlineStart={calcIndentation(indentation, isLeaf ? undefined : true) as Size}>
      <View padding={[0, '4px']}>
        <Flex height="9x" align="center" gap="2x">
          {!isLeaf && <Skeleton width="6x" height="6x" borderRadius="4px" />}
          <Skeleton height="5x" borderRadius="4px" />
        </Flex>
      </View>
    </View>
  );
}

export function TreeItemSkeletons() {
  return (
    <>
      <TreeItemSkeleton />
      <TreeItemSkeleton indentation={1} />
      <TreeItemSkeleton indentation={2} isLeaf={true} />
    </>
  );
}
